import React from 'react';
import PropTypes from 'prop-types';

// Helpers
import { getErrorKeyCase } from './constants';

// Components
import Modal from '../../../components/Modal/Modal';

// Styles
import * as styles from './ModalError.scss';

// Constants
import { supportEmail } from '../../../constants';

const ModalError = ({
  isOpen,
  onRequestClose,
  translate,
  error,
  isRtl
}) => {
  const errorLabels = getErrorKeyCase(error && error.details && error.details.errorKey);
  let title = errorLabels.title;
  const subTitle = errorLabels.subTitle;

  const isCodeError = error && error.status === 400 && error.message && error.message.includes('[code]');
  if (isCodeError) {
    title = 'code_validation_error';
  }

  if (error && [400, 401].includes(error.status) && error.message) {
    switch (error.message) {
      case 'No user with this email': {
        title = 'no_user_with_this_email';
        break;
      }
      case 'No user with this phone': {
        title = 'no_user_with_this_phone';
        break;
      }
      case 'Wrong password': {
        title = 'wrong_password';
        break;
      }
      case 'User with this email has already been registered.': {
        title = 'email_already_exists';
        break;
      }
      default: {
        break;
      }
    }
  }

  const shouldAskSupport = title === 'cannot_send_sms_at_this_moment';

  return (
    <Modal
      isOpen={isOpen}
      className={styles.modal}
      onRequestClose={onRequestClose}
      isRtl={isRtl}
    >
      <div className={styles.failModalContentWrapper}>
        <div className={styles.titleWrapper}>
          <p className={styles.failModalTitle}>{translate('authenticationPage', 'errorKeys', title)}</p>
          {subTitle && <p className={styles.failModalSubTitle}>{translate('authenticationPage', 'errorKeys', subTitle)}</p>}
        </div>
        {shouldAskSupport && (
          <p className={styles.failModalSubTitle}>
            <span>{translate('authenticationPage', 'askAgain')}</span>
            <span>
              <a href={`mailto:${supportEmail}`}>{translate('authenticationPage', 'supportLabel')}</a>
            </span>
          </p>
        )}
        <button
          onClick={onRequestClose}
          className={styles.failModalButton}
        >
          {translate('authenticationPage', 'return')}
        </button>
      </div>
    </Modal>
  );
};

ModalError.propTypes = {
  translate: PropTypes.func,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  error: PropTypes.object,
  isRtl: PropTypes.bool
};

export default ModalError;
